<div class="dashboard-tile" id="dialog-prompt" style="width:400px; min-height:250px; box-sizing:content-box;">
  <div class="tile-header">
    <div class="tile-header-title">{{ prompt }}</div>
  </div>
  <div class="tile-content" style="text-align: center">
    <h3 style="height: inherit;padding-top: 20px;margin-bottom: 9px;box-sizing: border-box;">{{ message }}</h3>
    <div class="tile-footer centered">
      <button class="mat-raised-button mat-primary" (click)="doResult('yes')">Yes</button>
      <button class="mat-raised-button" (click)="doResult('no')">No</button>
      <button class="mat-raised-button" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>
